import { StateType } from '../../types';

const slicePropertySelector = (sliceName: string, propertyName: string) => (state: StateType) =>
  state[sliceName]?.[propertyName];

export default slicePropertySelector;
